import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { PermissionsEffects } from './permissions.effects';
import { PERMISSIONS_FEATURE_KEY, permissionsReducer } from './permissions.reducer';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        EffectsModule.forFeature([PermissionsEffects]),
        StoreModule.forFeature(PERMISSIONS_FEATURE_KEY, permissionsReducer)
    ],
    providers: [PermissionsEffects]
})
export class PermissionsModule {}
